export const MATRIX_HEADINGS = [
    'Наименование модулей и дисциплин',
    'Ключевые компетенции',
    'Надпрофессиональные компетенции',
    'Общепрофессиональные компетенции',
    'Профессиональные компетенции',
];
